import { ProductInterface } from '@pylot-data/pylotschema'
import { getStoreConfig } from 'config'

enum responseStatus {
    success = 200,
    ok = 'OK'
}

export type YotpoBottomLineApiResponse = {
    response: {
        bottomline: {
            average_score: number
            total_reviews: number
        }
    }
    status: {
        code: responseStatus.success
        message: responseStatus.ok
    }
}

export type YotpoReviewJsonLd = {
    product: ProductInterface
    review: YotpoBottomLineApiResponse
}

export const yotpoJsonLd = ({ product, review }: YotpoReviewJsonLd) => {
    const config = getStoreConfig()

    if (
        !config.base.yotpo.enabled ||
        review?.status?.code !== responseStatus.success ||
        review?.status?.message !== responseStatus.ok
    ) {
        return product
    }

    const response = review?.response?.bottomline

    if (response?.total_reviews === 0) {
        //No review case
        return product
    }

    const productWithReview = { ...product } //clone object

    return {
        ...productWithReview,
        review_count: response?.total_reviews,
        review_summary: response?.average_score
    }
}
